import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/api/user/login',
    method: 'post',
    data
  })
}

export function thirdLogin(data) {
  return request({
    url: '/api/user/thirdLogin',
    method: 'post',
    data
  })
}